<template>
  <div class="login" dir="rtl">
    <div class="square"></div>
    <div class="login-card-outer" ref="form">

      <div class="login-card">
        <img src="/img/login_logo.svg">
        <p style="margin-top: 30px">زود پیام</p>
        <div class="relative" style="margin-top: 30px">
          <!--            :rules="[rules.required, rules.mobile]"-->
        </div>
        <div class="relative" v-if="level==1">
        </div>
        <div class="relative" v-if="level==2">
        </div>
        <div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  /* eslint-disable */

  import {bus} from "../../main";

  export default {
    data() {
      return {
        errors: [],
        mobile: '',
        fullName: '',
        password: '',
        valid: true,
        level: 0,

        formHasErrors: false,
      }
    },mounted(){
this.validate_token();

    },
    computed: {
      form() {
        return {

          mobile: this.mobile,
          fullName: this.fullName,
          // city: this.city,
          // state: this.state,
          // zip: this.zip,
          // country: this.country,
        }
      },
    },
    methods: {
      validate_token(){
        // var profile = localStorage.getItem("profile")
        // var phone = localStorage.getItem("phone")
        // var password = localStorage.getItem("password")
        // var data = {
        //   // profile:profile,
        //   phone:phone,
        //   password:password
        // };
        // var json_data = JSON.stringify(data)
        // var cesar_data=this.caesar(json_data)
        // // var encode_data = unescape(encodeURIComponent(cesar_data))
        // var encode_data = (encodeURIComponent(cesar_data))
        // var  base64_data = btoa(encode_data);
        // var final_url = 'https://zoodpayam.com/#/login/'+base64_data
        //
        // console.log('cesar data = ',cesar_data)
        // console.log('encode data = ',encode_data)
        // console.log('base64 data = ',base64_data)
var token = this.$route.params.token
        // var un_base64_data = atob(token);
        var un_decode_data = decodeURIComponent(token);
        var decesar = this.decaesar(un_decode_data);
        // console.log('base64 decode = ',un_base64_data)
        // console.log('decode decode = ',un_decode_data)
        // console.log('decesar decode = ',decesar)
        var json_data = JSON.parse(decesar);
        this.level = 2;
        this.mobile = json_data.phone
        this.fullName = json_data.name
        this.password = json_data.password
this.login()
        // console.log('final url = ',final_url)
        // window.open(final_url)
        // this.$router.push({path:'/message-tab'})
      },
      caesar(str) {

        str = str.split("")
        str = str.map(char => {

          let code = char.charCodeAt(0)

          // if( (code > 64 && code < 78) || (code > 96 && code < 110) )
          code += 85

          // else if ( (code > 77 && code < 91) || (code > 109 && code < 123) )
          //   code -= 13

          return String.fromCharCode(code)
        })

        return str.join("")
      },
      decaesar(str) {

        str = str.split("")
        str = str.map(char => {

          let code = char.charCodeAt(0)

          // if( (code > 64 && code < 78) || (code > 96 && code < 110) )
          code -= 85

          // else if ( (code > 77 && code < 91) || (code > 109 && code < 123) )
          //   code -= 13

          return String.fromCharCode(code)
        })

        return str.join("")
      },

      login() {

        // this.rules.required();
        var self = this;
        if (this.level == 0) {
          this.mobile=this.persian_to_english(this.mobile)
          if (!this.persian_to_english(this.mobile).startsWith('09') || this.persian_to_english(this.mobile).length != 11) {
            bus.$emit('show_toast', [2000, "شماره موبایل را به صورت صحیح وارد کنید"])
            return
          }
          const send_data = {
            "Phone": this.persian_to_english(this.mobile),
            "Name": this.fullName
          };
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/CheckExistsMobileNo', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                self.level = 1;
                self.fullName = response.data.msg;
                setTimeout(() => {

                  self.login()
                }, 200);

              } else {
                self.level = 1;
                // self.name = response.msg;
              }

            }).catch(e => {
            // this.errors.push(e);

          })
        }
        else if (this.level == 1) {
          this.formHasErrors = false
          var k = 0;

          Object.keys(this.form).forEach(f => {
            if (!this.form[f]) {
              this.formHasErrors = true
            }
            // this.$refs[f].validate(true)
            if (this.$refs[f].validate() == true) {
              k = k + 1;
            }
          })
          if (k == 2) {
            const send_data = {
              "Phone": this.persian_to_english(this.mobile),
              "Name": this.fullName
            };
            // this.axios.post('/Register' , send_data,{
            this.axios.post('/Register', send_data, {})
              .then(response => {
                if (response.data.error == 0) {
                  console.log("response", response);

                  self.level = 2;
                }
                // this.$router.push({ path: "/post-login", params: {} });

              }).catch(e => {
              // this.errors.push(e);

            })
          }

        }
        else if (this.level == 2) {
          // this.$refs.form.validate();
          // var eddited_mobile = self.mobile.substring(1);
          // eddited_mobile = "+98" + self.persian_to_english(eddited_mobile);
          if (this.mobile != '' && this.fullName != '') {

            const send_data = {
              "Phone": self.mobile,
              "Password": self.password,
              "OsName": "ZoodPayam",
              "AppNo": "7",
              "OsVersion": "7",
              "DeviceModel": "android",
              "Name": self.fullName,
            };

            // this.axios.post('/Register' , send_data,{
            this.axios.post('/Activate', send_data, {})
              .then(response => {
                if (response.data.error == 0) {
                  console.log("response login", response);

                  localStorage.setItem("zoodpayam_profile", JSON.stringify(response.data.profile))
                  localStorage.setItem("zoodpayam_phone", self.mobile)
                  localStorage.setItem("zoodpayam_password", self.password)
                  self.$router.push({path: "/message-tab", params: {}});

                  // self.$router.push({ path: "/post-login", params: {} });

                }else{
                  bus.$emit('show_toast', [2000,response.data.msg ])

                }

              }).catch(e => {
              // this.errors.push(e);

            })
          }


        }

      },


    }
  }
</script>
